export default {
  // Mode
  "common.mode.auto": "Mode menggunakan energi terbarukan secara otomatis",
  "common.mode.economy": "Mode ekonomi",
  "common.mode.exigency": "Mode keadaan darurat",

  // Perangkat
  "common.grid": "Jaringan listrik",
  "common.evChargers": "Stasiun pengisian kendaraan listrik (multiple)",
  "common.evCharger": "Stasiun pengisian kendaraan listrik",
  "common.pv": "Energi surya (PV)",
  "common.inverter": "Inverter (perangkat konversi listrik)",
  "common.pcs": "Inverter + baterai",
  "common.terminal": "Perangkat terminal",
  "common.airc": "AC (penyuhu udara)",
  "common.engine": "Mesin",
  "common.battery": "Baterai",
  "common.metter": "Meter listrik",
  "common.other": "Lainnya",
  "common.power": "Daya",
  "common.powerTotal": "Total daya",
  "common.voltage": "Voltase",
  "common.electricity": "Energi listrik",
  "common.current": "Arus listrik",
  "common.homeUsage": "Total beban rumah",
  "common.battery.power": "Daya baterai",

  // Data
  "common.noDataAvailable": "Data tidak tersedia saat ini~",
  "common.tips": "Tips",
  "common.reset": "Reset (bersihkan)",
  "common.currencyUnit": "¥ (Yuan)",
  "common.submiting": "Mengirim... Mohon tunggu...",
  "common.close": "Tutup",
  "common.from": "Dari",
  "common.useIn": "Untuk",
  "common.energyPercent": "Persentase aliran energi",
  "common.dataFlow": "Aliran data",
  "common.getDataIng": "Mengambil data... Mohon tunggu...",
  "common.pageLoading": "Memuat halaman... Mohon tunggu...",
  "common.reseting": "Mereset halaman... Mohon tunggu...",
  "common.save": "Simpan",
  "common.onlyNumberTips": "Hanya angka yang dapat dimasukkan",
  "common.offline": "Offline (tidak terhubung internet)",
  "common.online": "Online (terhubung internet)",
  "common.fault": "Kesalahan (masalah)",
  "common.charge": "Pengisian (baterai)",
  "common.discharge": "Pengosongan (penggunaan energi baterai)",
  "common.buy": "Beli",
  "common.sell": "Jual",
  "common.loadingInfo": "Memuat... Mohon tunggu...",

  // Fitur umum
  "common.moreFeatures": "Fitur lebih lanjut",
  "common.confirm": "Konfirmasi",
  "common.saveing": "Menyimpan... Mohon tunggu...",
  "common.searchPlacholder": "Masukkan kata kunci untuk mencari",
  "common.iSee": "Saya mengerti",
  "common.pageErrorTips1": "Oh, terjadi kesalahan pada halaman~",
  "common.pageErrorTips2": "Muat ulang halaman atau hubungi dukungan~",
  "common.refresh": "Muat ulang",
  "common.backToHome": "Kembali ke halaman utama",
  "common.checkTips": "Memeriksa... Mohon tunggu...",
  "common.back": "Kembali",
  "common.cancel": "Batal (hapus)",
  "common.optional": "Opsional (tidak wajib)",
  "common.required": "Wajib diisi",
  "common.status": "Status",
  "common.statusNoDelete": "Tidak dihapus",
  "common.statusDelete": "Dihapus",
  "common.submit": "Kirim",
  "common.disable": "Nonaktifkan",
  "common.enable": "Aktifkan",
  "common.year": "Tahun",
  "common.month": "Bulan",
  "common.day": "Hari",
  "common.version": "Versi:",
  "common.backHome": "Kembali ke halaman utama",
  "common.backHomeSorry": "Maaf, halaman telah menjadi tidak valid",
  "common.requestTips1": "Proses pengambilan data sedang berlangsung, jangan kirim ulang",
  "common.requestTips2": "Pemberitahuan sistem",
  "common.requestTips3": "Sesi login telah berakhir, silakan login kembali",
  "common.requestTips4": "Login kembali",
  "common.requestTips5": "Login tidak valid atau sesi telah berakhir, silakan login kembali.",
  "common.requestTips6": "Error server, silakan coba lagi nanti.",
  "common.requestTips7": "Permintaan sistem telah timeout",
  "common.requestTips8": "Sistem interface",
  "common.requestTips9": "Kesalahan",
  "common.iknow": "Saya mengerti",
  "common.logoutSuccess": "Logout berhasil",
  
  // Komponen informasi lebih lanjut
  "common.knowMore.title": "Untuk informasi lebih lanjut, hubungi Beineng",
  "common.knowMore.email": "Email untuk menghubungi",
  "common.knowMore.phone": "Nomor telepon untuk menghubungi",
  "common.knowMore.wechat": "WeChat untuk menghubungi",
  "common.knowMore.website": "Alamat situs resmi",
  "common.knowMore.address": "Alamat untuk menghubungi",
  "common.knowMore.addressDetail": "Unit 1205, 1301, Gedung 5, Jalan Qingxi 8, Kecamatan Huaning, Kota Nanjing, Provinsi Jiangsu",
  
  // Komponen koneksi lokal
  "common.localConnection": "Koneksi lokal",
  "common.operateInApp": "Lakukan operasi di dalam aplikasi!",
  
  "common.enbleStaus": "Status aktif",
  "common.battery.status": "Tidak sedang diisi, tidak sedang digunakan",

  // Terkait akun
  "account.forgetThePassword": "Lupa kata sandi",
  "account.logInDirectly": "Login langsung",
  "account.tips1": "Mengalihkan ke halaman... Mohon tunggu...",
  "account.tips2": "Pertama, baca dan terima syarat penggunaan!",
  "account.autoLogin": "Login otomatis",
  "account.userLogin": "Login pengguna",
  "account.registerTips": "Tidak memiliki akun? Klik di sini untuk mendaftar",
  "account.userEmail": "Nama pengguna / Email",
  "account.userEmailTips": "Masukkan nama pengguna atau email",
  "account.password": "Kata sandi",
  "account.passwordTips": "Masukkan kata sandi",
  "account.submit": "Kirim",
  "account.submitTips": "Mengirim... Mohon tunggu...",
  "account.otherLoginTips": "Atau pilih metode login lainnya",
  "account.userRegistration": "Registrasi pengguna",
  "account.userName": "Nama pengguna",
  "account.userNameTips": "Masukkan nama pengguna",
  "account.emailTips1": "Masukkan alamat email",
  "account.emailTips2": "Format email tidak valid",
  "account.phone": "Nomor telepon",
  "account.phoneTips1": "Masukkan nomor telepon",
  "account.phoneTips2": "Nomor telepon tidak valid",
  "account.phoneTips3": "Masukkan nomor telepon",
  "account.passwordTips1": "Masukkan kata sandi (6-30 karakter)",
  "account.passwordTips2": "Format kata sandi tidak valid: Kata sandi harus berisi huruf Inggris, angka, garis bawah (_), garis miring (-) dan titik (.), panjang 6-12 karakter",
  "account.passwordTips3": "Dua kata sandi yang dimasukkan tidak sama, silakan periksa dan masukkan kembali!",
  "account.passwordTips4": "Masukkan kata sandi: Kata sandi harus berisi huruf Inggris, angka, garis bawah (_), garis miring (-) dan titik (.)",
  "account.passwordTips5": "Konfirmasi kata sandi",
  "account.passwordTips6": "Masukkan untuk mengkonfirmasi kata sandi",
  "account.passwordTips7": "Dua kata sandi yang dimasukkan tidak sama, silakan periksa dan masukkan kembali!",
  "account.passwordTips8": "Masukkan untuk mengkonfirmasi kata sandi",
  "account.passwordTips9": "Selamat, registrasi berhasil!",
  "account.passwordTips10": "Nama pengguna Anda adalah:",
  "account.emailIs": "Email Anda adalah:",
  "account.goToLoginPage": "Akan dialihkan ke halaman login secara otomatis dalam s detik",
  "account.goLogin": "Login",
  "account.goRegister": "Daftar",
  "account.loginSuccess": "Login berhasil",
  "account.email": "Email",
  "account.sologn": "Kami menciptakan platform energi terintegrasi yang dirancang khusus untuk Anda",
  "account.pleaseAgree": "Saya telah membaca dan menyetujui",
  "userAgreement.privacyPolicy": "Kebijakan privasi",

  // Terkait kode verifikasi
  "account.code": "Kode verifikasi",
  "account.codeTips": "Masukkan kode verifikasi",
  "account.codeTips2": "Kode verifikasi tidak valid",

    "account.inviteCodeTips": "Silakan masukkan kode undangan",
    "account.inviteCodeHint": "Silakan hubungi pemasang atau staf operasi dan pemeliharaan untuk mendapatkan kode undangan",
  // Perubahan dan pemulihan kata sandi
  "account.modifyPasswordByAccount": "Ubah kata sandi melalui akun",
  "account.modifyPasswordByEmail": "Ubah kata sandi melalui email",
  "account.getPasswordByAccount": "Dapatkan kata sandi melalui akun",
  "account.getPasswordByEmail": "Dapatkan kata sandi melalui email",

  "account.sendEmailTips": "Kode verifikasi telah dikirim ke email, silakan periksa",
  "account.name": "Nama akun",
  "account.newPassword": "Kata sandi baru",
  "account.confirmNewPassword": "Konfirmasi kata sandi baru",
  "account.nameTips": "Masukkan nama akun",
  "account.passwordModifySuccess": "Perubahan kata sandi berhasil",
  "account.emailCode": "Kode verifikasi email",
  "account.emailCodeTips": "Masukkan kode verifikasi email",
  "account.emailCodeTips2": "Kode verifikasi email tidak valid",
  "account.emailModifySuccess": "Perubahan kata sandi berhasil",
  "account.passworTips1": "Kata sandi Anda telah direset!",
  "account.passwordTips11": "Masukkan untuk mengkonfirmasi kata sandi",
  "account.passwordTips12": "Masukkan kata sandi baru",
  "account.nickname": "Nama panggilan",
  "account.modifyNickname": "Ubah nama panggilan",
  "account.modifyNicknameSuccess": "Perubahan nama panggilan berhasil!",
  "account.nicknameTips": "Masukkan nama panggilan",
  "account.nicknameError": "Perubahan nama panggilan gagal!",

  // Registrasi dan login cepat
  "account.login": "Login",
  "account.quickRegister": "Registrasi cepat",
  "account.sendCode": "Kirim kode verifikasi",
  "account.sendTips": "Dapat mengirim ulang dalam s detik",
  "account.sendEmailIng": "Mengirim email... Mohon tunggu...",
  "account.emailNotEmpty": "Kolom email tidak boleh kosong",
  "account.registerAccount": "Registrasi akun",
  "account.registerWelcome": "Selamat datang di registrasi SusprSafe",
  "account.usernameLimit": "Nama pengguna harus dimulai dengan huruf, hanya boleh berisi huruf, angka dan garis bawah (_), panjang 5-15 karakter",

  // Informasi hak cipta
  "copyright.desc2": "Informasi registrasi situs: Nomor registrasi ICP Provinsi Jiangsu 2021169764",

  // Edit informasi pengguna
  "editUserInfo.editUserInformation": "Edit informasi pengguna",
  "editUserInfo.modifyUsername": "Ubah nama pengguna",
  "editUserInfo.changePictures": "Ubah foto profil",
  "editUserInfo.savePicturesSuccess": "Penyimpanan foto profil berhasil",
  "editUserInfo.saveError": "Penyimpanan gagal",
  "editUserInfo.pictureLimit": "Ukuran foto tidak boleh lebih dari 2 MB",
  "editUserInfo.uploadPicture": "Unggah foto profil",
  "editUserInfo.picturePreview": "Pratinjau",
  
  "editUserInfo.bindPhoneNumber": "Hubungkan nomor telepon",
  "editUserInfo.bindEmail": "Hubungkan email",
  "editUserInfo.changePassword": "Ubah kata sandi",

  "editUserInfo.notificationSettings": "Pengaturan pemberitahuan",
  "editUserInfo.editAccount": "Edit informasi akun",
  "editUserInfo.waitBingting": "Menghubungkan... Mohon tunggu...",
  "editUserInfo.collapse": "Ciutkan (pisahkan)",
  "editUserInfo.modifyBinding": "Ubah hubungan",
  
  "editUserInfo.emailAddress": "Alamat email",
  "editUserInfo.tips1": "Pembindingan email berhasil",
  "editUserInfo.tips2": "Penyimpanan gagal",
  "editUserInfo.tips3": "Mengirim kode verifikasi email... Mohon tunggu...",
  "editUserInfo.tips4": "Kode verifikasi telah dikirim ke email xxxx, silakan periksa",
  "editUserInfo.tips5": "Pengiriman kode verifikasi gagal!",
  "editUserInfo.tips6": "Nomor telepon telah terhubung",
  "editUserInfo.tips7": "Email telah terhubung",
  "editUserInfo.emailTips1": "Masukkan alamat email",
  "editUserInfo.emailTips2": "Format email tidak valid",
  "editUserInfo.emailTips3": "Dapat mengirim ulang dalam xxxx detik",
  "editUserInfo.emailTips4": "Kirim kode verifikasi",
  "editUserInfo.emailTips5": "Kolom kode verifikasi email tidak boleh kosong",
  "editUserInfo.emailTips6": "Kode verifikasi email tidak valid",
  "editUserInfo.emailCode": "Kode verifikasi email",
  "editUserInfo.save": "Simpan",

  // Terkait pembindingan telepon
  "editUserInfo.phoneTips1": "Pembindingan nomor telepon berhasil",
  "editUserInfo.phoneTips2": "Mengirim kode verifikasi SMS... Mohon tunggu...",
  "editUserInfo.phoneTips3": "Kode verifikasi SMS telah dikirim ke nomor xxxx, silakan periksa",
  "editUserInfo.phoneTips4": "Pengiriman kode verifikasi SMS gagal!",
  "editUserInfo.phoneTips5": "Masukkan nomor telepon",
  "editUserInfo.phoneTips6": "Format nomor telepon tidak valid",
  "editUserInfo.phoneTips7": "Kirim kode verifikasi SMS",
  "editUserInfo.phoneTips8": "Kode verifikasi SMS",
  "editUserInfo.phoneTips9": "Kolom kode verifikasi SMS tidak boleh kosong",
  "editUserInfo.phoneTips10": "Kode verifikasi SMS tidak valid",
  "editUserInfo.phone": "Nomor telepon",


  // Pengaturan pemberitahuan
  "editUserInfo.noticeTips1": "Gagal mengambil pengaturan pemberitahuan!",
  "editUserInfo.noticeTips2": "Penyimpanan pengaturan pemberitahuan berhasil!",
  "editUserInfo.noticeTips3": "Pemberitahuan tingkat baterai rendah",
  "editUserInfo.noticeTips4": "Pemberitahuan selesai pengisian stasiun pengisian",
  "editUserInfo.errorNotification": "Pemberitahuan kesalahan",
  "editUserInfo.updateNotification": "Pemberitahuan pembaruan",
  "editUserInfo.monthlyStatisticsNotification": "Pemberitahuan statistik bulanan",
  "editUserInfo.notificationMethod": "Metode penerimaan",

  // Tips terkait nama pengguna
  "editUserInfo.userNameTips1": "Penyimpanan nama pengguna berhasil",
  "editUserInfo.userNameTips2": "Penyimpanan nama pengguna gagal",
  "editUserInfo.userNameTips3": "Masukkan nama pengguna",
  "editUserInfo.userNameTips4": "Format nama pengguna tidak valid: Hanya boleh berisi angka, garis bawah (_) dan huruf Inggris",
  "editUserInfo.userNameTips5": "Masukkan nama pengguna",
  "editUserInfo.userNameTips6": "Menyimpan... Mohon tunggu...",
  "editUserInfo.userName": "Nama pengguna",

  // Tips edit foto profil
  "editUserInfo.avatorTips": "Klik untuk mengubah foto profil",
  "editUserInfo.verifyCodeTips1": "Masukkan kode verifikasi yang diterima:",
  "editUserInfo.verifyCodeTips2": "Untuk keamanan akun Anda, klik tombol di bawah untuk mengirim kode verifikasi ke nomor telepon asli:",
  "editUserInfo.verifyCodeTips3": "Kirim kode verifikasi",
  "editUserInfo.verifyCodeTips4": "Verifikasi nomor telepon asli berhasil, masukkan nomor telepon baru yang akan dihubungkan",
  "editUserInfo.verifyCodeTips5": "Untuk keamanan akun Anda, klik tombol di bawah untuk mengirim kode verifikasi ke email asli:",
  "editUserInfo.verifyCodeTips6": "Verifikasi email asli berhasil, masukkan email baru",
  "editUserInfo.verifyCodeTips7": "Kata sandi lama",
  "editUserInfo.verifyCodeTips8": "Pertama, hubungkan email!",
  "editUserInfo.verifyCodeTips9": "Kode verifikasi telah dikirim ke email, silakan periksa",
  "editUserInfo.verifyCodeTips10": ", akan dialihkan ke halaman login secara otomatis",

  // Terkait pemberitahuan
  "hems.notice.title": "Judul pemberitahuan", 
  "hems.notice.content": "Isi pemberitahuan", 
  "hems.notice.operate": "Operasi",
  "hems.notice.noRead": "Belum dibaca",
  "hems.notice.read": "Sudah dibaca",
  "hems.notice.warning": "Peringatan",
  "hems.notice.error": "Kesalahan",
  "hems.notice.success": "Statistik penghitungan",
  "hems.notice.sys": "Informasi sistem",
  "hems.notice.operateSuccess": "Operasi berhasil",
  "hems.notice.operateTips": "Pilih item untuk dioperasikan",

  // Halaman utama
  "hems.home.selfuseRate": "Persentase penggunaan pribadi",
  "hems.home.percent": "Persentase",
  "hems.home.todayData": "Data hari ini",
  "hems.home.todayPowerGeneration": "Pembangkitan energi hari ini",
  "hems.home.salesIncome": "Pendapatan penjualan energi",
  "hems.home.saved": "Anda telah menghemat",
  "hems.home.reduce": "Mengurangi jejak karbon",
  "hems.home.tips1": "Data tidak tersedia saat ini, Anda belum menghubungkan xxxx",
  "hems.home.criticalLoad": "Beban kritis",
  "hems.home.keyVoltage": "Voltase kritis",
  "hems.home.householdLoad": "Beban rumah",
  "hems.home.householdVoltage": "Voltase rumah",
  "hems.home.generalLoad": "Beban umum",
  "hems.home.generalVoltage": "Voltase umum",
  "hems.home.batteryHealth": "Status kesehatan baterai",
  "hems.home.averageTemp": "Suhu rata-rata",
  "hems.home.gridLoad": "Beban jaringan listrik",
  "hems.home.toggeleDataSource": "Data yang ditampilkan telah diubah sebagai berikut:",
  "hems.home.toggleTips": "Apakah Anda ingin mengubah?",
  "hems.home.modeSending": "Mengirim perintah mode... Mohon tunggu...",
  "hems.home.modeSuccess": "Perubahan mode berhasil dikirim!",
  "hems.home.isOnline": "Apakah online?",
  "hems.home.useStatus": "Status penggunaan",
  "hems.home.workModeText": "Mode kerja saat ini:",
  "hems.home.toggleDataSourceText": "Data yang ditampilkan telah diubah sebagai berikut:",
  "hems.ev.charge.status": "Status pengisian",
  "hems.ev.charge.time": "Waktu pengisian",
  "hems.ev.charge.count": "Jumlah pengisian aktual (seiring waktu)",
  "hems.ev.charge.status.empty": "Kosong",
  "hems.ev.charge.status.ing": "Terhubung ke baterai. Sedang mengisi",
  "hems.ev.charge.status.null": "Terhubung ke baterai, tetapi tidak sedang mengisi",
  "hems.ev.charge.status.error": "Kesalahan",
  "hems.hour": "Jam",
  "hems.minue": "Menit",
  "hems.ev.chagre.number": "Nomor stasiun pengisian",

  // Panduan pengguna
  "hems.userGuide.selfUse": "Penggunaan energi terbarukan pribadi",
  "hems.userGuide.selfUseTips": "Pertama, gunakan energi surya, jika tidak cukup, isi dengan jaringan listrik",
  "hems.userGuide.economyMode": "Mode ekonomi",
  "hems.userGuide.economyModeTips": "Optimalkan strategi penggunaan energi berdasarkan tarif energi listrik",
  "hems.userGuide.emergencyMode": "Mode keadaan darurat",
  "hems.userGuide.emergencyModeTips": "Prioritaskan dukungan energi untuk beban kritis",

  // Halaman grafik
  "hems.history.energyStatistics": "Statistik energi",
  "hems.history.revenueStatistics": "Statistik pendapatan",
  "hems.history.greenStatistics": "Pengurangan emisi hijau",
  "hems.history.revenueTitle": "Total pendapatan penjualan energi",
  "hems.history.savingsTitle": "Total penghematan",
  "hems.history.carbonTitle": "Total pengurangan karbon",
  "hems.history.day": "Hari",
  "hems.history.month": "Bulan",
  "hems.history.year": "Tahun",
  "hems.history.beforeDay": "Kemarin",
  "hems.history.afterDay": "Besok",
  "hems.history.beforeMonth": "Bulan lalu",
  "hems.history.afterMonth": "Bulan depan",
  "hems.history.beforeYear": "Tahun lalu",
  "hems.history.afterYear": "Tahun depan",
  "hems.history.totalUse": "Total penggunaan",
  "hems.history.fullScreen": "Layar penuh",
  "hems.history.timeSelect": "Pilih hari",
  "sync.tips1": "Perintah sinkronisasi data berhasil dikirim!",
  "sync.tips2": "Melakukan sinkronisasi data, memerlukan waktu karena jumlah data besar, periksa kembali dalam 50 menit~",
  "sync.tips3": "Sinkronisasi data perangkat mungkin tertunda, jika Anda melihat inkonsistensi dalam data, klik tombol di bawah:",
  "sync.tips4": "Sinkronkan data",

  // Informasi stasiun pengisian
  "charge.info": "Informasi stasiun pengisian",
  "news.loading": "Memuat...",
  "news.noMore": "Tidak ada data lagi",
  "hems.pv.power": "Jumlah energi surya",

  // Fitur khusus UEH
  "ueh.sellPower": "Jumlah energi yang dijual",
  
  // Menu
  "menu.home": "Halaman utama",
  "menu.history": "Data riwayat",
  "menu.device": "Perangkat",
  "menu.settings": "Pengaturan",
  "menu.messageCenter": "Pusat pesan",
  "menu.help": "Bantuan dan dukungan",
  "menu.mine": "Saya (pribadi)",


  // Pengaturan saya
  "mine.userSetting": "Pengaturan pengguna",
  "mine.terminalSetting": "Pengaturan dasar perangkat terminal",
  "mine.uploadCloud": "Unggah data ke cloud",
  "mine.changeVersion": "Periksa pembaruan",
  "mine.language": "Ubah bahasa",
  "mine.about": "Tentang aplikasi",
  "mine.feedback": "Umpan balik",
  "mine.logout": "Keluar",
  "mine.logoutAccount": "Hapus akun",

  // Terkait penghapusan akun
  "mine.logoutAccountTips": "Hapus akun bernama []",
  "mine.logoutAccountTips1": "Hapus akun yang terhubung dengan []",
  "mine.logoutAccountCare": "Catatan permintaan penghapusan akun:",
  "mine.logoutAccountCare1": "1. Akun dalam keadaan aman semuanya",
  "mine.logoutAccountCare1-1": "Akun dalam keadaan penggunaan normal, tidak ada risiko pencurian, pelanggaran aturan atau penutupan",
  "mine.logoutAccountCare2": "2. Hak akses dan hubungan akun dihapus",
  "mine.logoutAccountCare2-1": "Semua hak akses akun untuk platform pihak ketiga dihapus",
  "mine.logoutAccountCare3": "3. Setelah dihapus, akun tidak dapat dipulihkan, data pengguna dihapus",
  "mine.logoutAccountCare3-1": "Setelah dihapus, nomor telepon, email dan data terkait yang terhubung dihapus, tidak dapat dipulihkan",
  "mine.confirmLogout": "Konfirmasi penghapusan",
  "mine.logoutSuccess": "Penghapusan akun berhasil!",


  // Masalah umpan balik
  "mine.feedbackIssues": "Masalah dan umpan balik",
  "mine.feedQuantity": "Jumlah",
  "mine.feedAmount": "Maksimal 9 foto, ukuran maksimal setiap foto 1 MB",

  // Terkait pengaturan pemberitahuan
  "mine.notice.fail": "Gagal mengambil pengaturan pemberitahuan!",
  "mine.notice.saveSuccess": "Penyimpanan pengaturan pemberitahuan berhasil!",
  "mine.notice.saveFail": "Penyimpanan gagal!",
  "mine.notice.title": "Pengaturan pemberitahuan",
  "mine.notice.batteryLow": "Pemberitahuan tingkat baterai rendah",
  "mine.notice.chargingFinish": "Pemberitahuan selesai pengisian stasiun pengisian",
  "mine.notice.error": "Pemberitahuan kesalahan",
  "mine.notice.update": "Pemberitahuan pembaruan",
  "mine.notice.monthly": "Pemberitahuan statistik bulanan",
  "mine.notice.receiveType": "Metode penerimaan",

  // Pesan selamat datang pengaturan bahasa
  "mine.language.welcome": "Selamat datang di SusprSafe",
  "mine.language.desc1": "Pilih versi bahasa berdasarkan lokasi tempat Anda tinggal",
  "mine.language.desc2": "Anda dapat mengubahnya kapan saja di pengaturan aplikasi",

  // Informasi pribadi
  "mine.userInfo.avatar": "Foto profil",
  "mine.userInfo.nickname": "Nama panggilan",
  "mine.userInfo.password": "Kata sandi",
  "mine.userInfo.changePassword": "Ubah kata sandi",
  "mine.userInfo.setPassword": "Atur kata sandi",
  "mine.userInfo.phoneNumber": "Nomor telepon",
  "mine.userInfo.bindPhone": "Hubungkan nomor telepon",
  "mine.userInfo.bindEmail": "Hubungkan email",
  "mine.loginExpired": "Sesi login telah berakhir, silakan login kembali",
  "mine.userInfo.title": "Informasi pengguna",
  "mine.userInfo.bind": "Hubungkan",
  "mine.userInfo.modify": "Ubah",
  "mine.userInfo.modifyNickname": "Ubah nama panggilan",
  "mine.userInfo.userNickname": "Nama panggilan pengguna",
  "mine.userInfo.selectPic": "Pilih foto untuk diunggah",
  "mine.userInfo.saveSuccess": "Penyimpanan berhasil",
  "mine.userInfo.uploadFail": "Pengunggahan gagal",
  "mine.userInfo.avatarSaveSuccess": "Penyimpanan foto profil berhasil",
  "mine.userInfo.nameTips1": "Kolom nama panggilan tidak boleh kosong",
  "mine.userInfo.nameTips2": "Masukkan nama panggilan",

  // Tips pilihan umum
  "common.pleaseSelect": "Silakan pilih",
  "question.commonQuestions": "Pertanyaan umum yang sering diajukan",
  "account.toggleLanguage": "Ubah bahasa",
  "account.localConnection": "Koneksi lokal",
  "account.selectLanguage": "Silakan pilih bahasa",
  "account.sendEmailToast": "Kode verifikasi telah dikirim ke email xxx, silakan periksa",
  "account.emailError": "Format email tidak valid",
  "account.sendEmailFail": "Pengiriman gagal, silakan coba lagi",
  
  "common.submitting": "Mengirim... Mohon tunggu...",

  "device.page.noData": "Data tidak tersedia saat ini, halaman ini hanya dapat dilihat dalam aplikasi"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};